export default __webpack_public_path__ + "static/media/GH_kitchen.c6b815ca.jpg";